module.exports = __webpack_public_path__ + "static/media/Basic Package.3c5c2453.pdf";